import { getImageSize } from 'react-image-size';

export async function fetchImageSize(url) {
  try {
    const dimensions = await getImageSize(url);
    return dimensions || { width: 0, height: 0 };
  } catch (error) {
    console.error(error);
    return { width: 0, height: 0 };
  }
}

export function getImageJustification(getSingleImage) {
  let imageJustify = '';
  if (getSingleImage !== null) {
    if (getSingleImage.justify === 'R') {
      imageJustify = 'right';
    } else if (getSingleImage.justify === 'L') {
      imageJustify = 'left';
    } else {
      imageJustify = 'center';
    }
  }
  return imageJustify;
}

export async function getImgCords(image) {
  const { width, height } = await fetchImageSize(
    image?.isNewLogo === '1' ? image.processedImage : image.image,
  );

  let maxValue = Number.MIN_VALUE;
  let ratio = 1;
  let newX = image?.isNewLogo === '1' ? image.newX : image.x;
  let newY = image?.isNewLogo === '1' ? image.newY : image.y;
  let newW = image?.isNewLogo === '1' ? image.newW : image.w;
  let newH = image?.isNewLogo === '1' ? image.newH : image.h;

  let newIw = width,
    newIh = height;
  if (height > 800 || width > 800) {
    maxValue = Math.max(width, height);
    if (maxValue === height) {
      ratio = 800 / height;
      newIh = 800;
      newIw = ratio * width;
    } else {
      ratio = 800 / width;
      newIw = 800;
      newIh = height * ratio;
    }
  }
  if (ratio !== 1) {
    newW = (newW * 100) / newIw;
    newX = (newX * 100) / newIw;
    newY = (newY * 100) / newIh;
    newH = (newH * 100) / newIh;
  } else {
    newW = (newW * 100) / width;
    newX = (newX * 100) / width;
    newY = (newY * 100) / height;
    newH = (newH * 100) / height;
  }
  return { newX, newY, newW, newH };
}
